import { grabLocations } from "../dataLayer/locations";
import { Location } from "../interfaces/LocationsInterface";

class LocationsManager {

    // Method to retrieve locations
    async getLocations(): Promise<any> {
        try {
            // Call the grabEmployees function to fetch locations data
            const authData : Location[] = await grabLocations();

            // Log the successful retrieval of locations data for debugging purposes
            console.log("Grab successful:", authData);

            // Return the locations data (authentication data in this context)
            return authData;

        } catch (error) {
            // Log any errors that occur during the data retrieval process
            console.error("Error during grabbing locations:", error);

            // Rethrow the error to be handled by the calling code
            throw error;
        }
    }

}

// Export an instance of the LocationsManager class to be used elsewhere in the application
export default new LocationsManager();
